export const DENIM = 'denim';
export const DARK = 'dark';
export const LIGHT = 'light';
export const CIRCLE_SUCCESS = 'circleSuccess';
export const CIRCLE_DANGER = 'circleDanger';
export const CIRCLE_ICON = 'circleWithIcon';
export const ICON_ONLY = 'iconOnly';
export const BOX_LIGHT = 'boxLight';



// WEBPACK FOOTER //
// ./app/components/button/variants.js